import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DemService {
  demData: any;
  selectedId: any
  refreshDemList: Subject<any> = new Subject<any>();
  deleteDemListData: Subject<any> = new Subject<any>();
  constructor(private http: HttpClient) { }


  getAllDEM(mapId: any) {
    return this.http.get('/data/dem/', {
      params: {
        map_id: parseInt(mapId),
      },
    });
  }


  addDemFile(body: any): Observable<any> {
    return this.http.post<any>('/data/dem/', body);
  }

  public deleteDem(id: any): Observable<any> {
    return this.http.delete(`/data/dem/${id}/`);
  }

  getDEMTiff(fileId: any) {
    return this.http.get(`/data/create-dem-tiff/${fileId}`);
  }

  makeHttpRequest(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      switchMap((response: Blob) => {
        console.log(response);
        return new Observable<Blob>((observer) => {
          observer.next(response);
          observer.complete();
        });
      })
    );
  }

  public setRefreshDem(value: any) {
    this.refreshDemList.next(value);
  }

  public deleteDemList(value: any): void {
    this.deleteDemListData.next(value);
  }
}
